import { AVAILABLE_OPERATORS } from 'components/AIConfiguration/LeadQualification/constants'

import {
  DEFAULT_INPUT,
  DEFAULT_VALIDATION,
  OPERATOR_COMPONENTS_AND_VALIDATIONS,
} from './attributeValueFactory'

export const useAttributeValueFactory = (
  operator = AVAILABLE_OPERATORS.EQUAL
) => {
  const {
    component,
    validation,
    defaultValue = '',
  } = OPERATOR_COMPONENTS_AND_VALIDATIONS[
    operator || AVAILABLE_OPERATORS.EQUAL
  ] || {
    component: DEFAULT_INPUT,
    validation: DEFAULT_VALIDATION,
    defaultValue: '',
  }

  return {
    component,
    validation,
    defaultValue,
  }
}
